import { useState } from "react";
import ReportStyles from "../../styles/pages/Summaries/ReportStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import { StyledFlexDiv } from "../../styles/MainStyles";
import ModalGenerateReport from "./ModalGenerateReport";
import { IReportCardProps, ReportData } from "../../model/Report";

const {
    StyledReportCardDiv,
    StyledReportCardTitle,
    StyledReportCardText,
    StyledReportCardInfo,
} = ReportStyles;

const ReportCard: React.FC<IReportCardProps> = ({
    icon,
    cardId,
    title,
    data,
    description,
    buttonIcon,
    imgDescription,
    imgButtonDescription,
}) => {
    const [dataToGenerate, setDataToGenerate] = useState<any>(null);
    const [openModalGenerateReport, setOpenModalGenerateReport] =
        useState(false);
    const { BtnOutlinePrimary } = ButtonStyles;

    const handleOpenModalGenerateReport = (info: ReportData) => {
        setOpenModalGenerateReport(true);
        setDataToGenerate(info);
    };

    const handleCloseModalGenerateReport = () => {
        setOpenModalGenerateReport(false);
    };

    const generateReport = (
        <ModalGenerateReport
            open={openModalGenerateReport}
            dataReport={dataToGenerate}
            onClose={handleCloseModalGenerateReport}
        />
    );

    return (
        <StyledReportCardDiv>
            <StyledFlexDiv style={{ alignItems: "center" }}>
                <div>{!!icon && <img src={icon} alt={imgDescription} />}</div>
                <StyledReportCardInfo>
                    <StyledReportCardTitle>{title}</StyledReportCardTitle>
                    <StyledReportCardText>{description}</StyledReportCardText>
                </StyledReportCardInfo>
            </StyledFlexDiv>
            <BtnOutlinePrimary
                style={{ width: "180px", height: "40px" }}
                onClick={() =>
                    handleOpenModalGenerateReport({
                        nome: title,
                        parametros: data,
                        id: cardId,
                    })
                }
            >
                <img
                    src={buttonIcon}
                    alt={imgButtonDescription}
                    style={{ margin: "0 10px" }}
                />
                Gerar relatório
            </BtnOutlinePrimary>
            {openModalGenerateReport && generateReport}
        </StyledReportCardDiv>
    );
};

export default ReportCard;
